export default {
  label: '处理信息',
  icon: 'el-icon-success',
  column: [
    {
      type: 'input',
      label: '录入人员',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processInputPeople',
      disabled: true,
    },
    {
      type: 'input',
      label: '维修人员',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processMaintainPeople',
      maxlength: 10,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '请填写维修人员',
          trigger: 'blur',
        },
      ],
    },
    {
      type: 'select',
      label: '处理部门',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processDeptId',
      formslot: true,
      clearable: true,
      rules: [
        {
          required: true,
          message: '请选择处理部门',
          trigger: 'blur',
        },
      ],
    },
    {
      type: 'datetime',
      label: '派单时间',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processSendOrderTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      type: 'datetime',
      label: '到场时间',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processPresentTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      type: 'datetime',
      label: '完成时间',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processFinishTime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      rules: [
        {
          required: true,
          message: '请选择完成时间',
          trigger: 'blur',
        },
      ],
    },
    {
      type: 'select',
      label: '处理类别',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processType',
      dataType: 'number',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dicUrl: '/api/blade-system/dict/dictionary?code=complaint_manage_type',
      clearable: true,
    },
    {
      type: 'input',
      label: '处理内容',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processDesc',
      maxlength: 100,
      showWordLimit: true,
    },
    {
      type: 'select',
      label: '处理结果',
      span: 8,
      display: true,
      size: 'small',
      prop: 'processResult',
      dicData: [
        {
          label: '处理中',
          value: 1,
        },
        {
          label: '处理完成',
          value: 2,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择处理结果',
          trigger: 'blur',
        },
      ],
    },
    {
      type: 'textarea',
      label: '处理备注',
      span: 24,
      display: true,
      size: 'small',
      prop: 'remark2',
      maxlength: 200,
      showWordLimit: true,
    },
    {
      label: '物料明细',
      span: 24,
      display: true,
      prop: 'materials',
      formslot: true,
    },
    {
      label: '文件上传',
      prop: 'accessoriesStr3',
      type: 'upload',
      span: 24,
      propsHttp: {
        res: 'data',
        url: 'link',
        name: 'originalName',
      },
      tip: '只能上传不超过5M的文件或图片',
      action: '/api/v4ward/oss/customEndpoint/put-file',
      dataType: 'string',
    },
    {
      label: '上传签名',
      prop: 'accessoriesSign',
      type: 'upload',
      listType: 'picture-img',
      action: '/api/blade-resource/oss/endpoint/put-file',
      propsHttp: {
        res: 'data',
        url: 'link',
        name: 'originalName',
      },
      accept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
      span: 24,
      tip: '只能上传不超过5M的图片',
      rules: [
        {
          required: true,
          message: '请上传签名',
          trigger: 'blur',
        },
      ],
    },
  ],
};
